import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./lib/auth";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import InstallPrompt from "./components/InstallPrompt";

import Home from "./pages/Home";
import Cars from "./pages/Cars";
import CarDetail from "./pages/CarDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Sell from "./pages/Sell";
import DealerDashboard from "./pages/DealerDashboard";
import DealerOnboarding from "./pages/DealerOnboarding";
import AdminPanel from "./pages/AdminPanel";
import Favourites from "./pages/Favourites";
import Profile from "./pages/Profile";
import {
  TermsPage,
  PrivacyPage,
  RefundPage,
  DisclaimerPage,
} from "./pages/Legal";

function Shell({ children }) {
  return (
    <div className="App flex flex-col min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cars" element={<Cars />} />
            <Route path="/cars/:id" element={<CarDetail />} />
            <Route path="/sell" element={<Sell />} />
            <Route path="/dealer-onboarding" element={<DealerOnboarding />} />
            <Route path="/dealer-signup" element={<Navigate to="/dealer-onboarding" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dealer" element={<DealerDashboard />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/favourites" element={<Favourites />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/refund-policy" element={<RefundPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Shell>
        <Toaster position="top-right" richColors closeButton />
        <InstallPrompt />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
